import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'timeZone'
})
export class TimeZonePipe implements PipeTransform {

  transform(time: string, date: string, timeZone: string): string {
     const formatDate = moment(date).format("YYYY-MM-DD");
     const dt = new Date(`${formatDate} ${time}:00 UTC`);
     const convertedTime = timeZone
    ? moment(dt).tz(timeZone).format('hh:mm a (z)')
    : moment(dt).format('hh:mm a');
  return convertedTime;
  }

}
